/* drawer add-ons, a/b vs rebuy popup. arm a: popup, block hidden. arm b: no popup, block shown. arm set in theme.liquid head (?addons=a|b forces it), goes on the cart as _ab_addons. */
(() => {
  if (window.atlasAddons) return;
  window.atlasAddons = true;

  const arm = document.documentElement.getAttribute('data-ab-addons');
  const POPUP = '245272';

  // arm b: pull the rebuy popup block before rebuy loads (first tap)
  const dropPopup = () => {
    if (arm !== 'b') return;
    document.querySelectorAll(`[id$="__rebuy_${POPUP}"], #rebuy-widget-${POPUP}`).forEach((el) => el.remove());
  };
  dropPopup();
  document.addEventListener('DOMContentLoaded', dropPopup);

  // 3rd slot: one contender per cart, stable per cart (fnv-1a of cart token + ids)
  const hash = (text) => {
    let h = 2166136261;
    for (let i = 0; i < text.length; i += 1) {
      h ^= text.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  };
  const pickContender = (block) => {
    const contenders = [...block.querySelectorAll('[data-atlas-contender]')];
    if (!contenders.length || contenders.some((c) => c.classList.contains('is-picked'))) return;
    const key = (block.dataset.cartToken || '') + contenders.map((c) => c.dataset.pid).join(',');
    contenders[hash(key) % contenders.length].classList.add('is-picked');
  };

  // arm on the cart once it has items; arm b also logs what was shown (_atlas_seen, last 40 ids). one request per new sighting, not per page
  let syncing = false;
  const syncArm = () => {
    const blocks = [...document.querySelectorAll('[data-atlas-addons]')];
    blocks.forEach(pickContender);
    if (!arm || syncing || !blocks.length) return;
    const attributes = {};
    if (blocks[0].dataset.abAttr !== arm) attributes._ab_addons = arm;
    if (arm === 'b') {
      const seen = (blocks[0].dataset.seenAttr || '').split(',').filter(Boolean);
      const before = seen.length;
      blocks.forEach((block) => {
        block.querySelectorAll('.atlas-addons__item').forEach((item) => {
          const shown = !item.hasAttribute('data-atlas-contender') || item.classList.contains('is-picked');
          if (shown && !seen.includes(item.dataset.pid)) seen.push(item.dataset.pid);
        });
      });
      if (seen.length > before) attributes._atlas_seen = seen.slice(-40).join(',');
    }
    if (!Object.keys(attributes).length) return;
    syncing = true;
    fetch(`${window.routes ? window.routes.cart_update_url : '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    })
      .then(() =>
        document.querySelectorAll('[data-atlas-addons]').forEach((b) => {
          if (attributes._ab_addons) b.dataset.abAttr = attributes._ab_addons;
          if (attributes._atlas_seen) b.dataset.seenAttr = attributes._atlas_seen;
        })
      )
      .catch(() => {})
      .finally(() => (syncing = false));
  };

  const watch = () => {
    syncArm();
    ['cart-drawer', 'cart-items'].forEach((tag) => {
      const host = document.querySelector(tag);
      if (host) new MutationObserver(syncArm).observe(host, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  // The cart page: the same sections Dawn re-renders after a quantity change.
  const renderPage = (cartItems, json) => {
    cartItems.getSectionsToRender().forEach((section) => {
      const host = document.getElementById(section.id);
      const html = json.sections[section.section];
      if (!host || !html) return;
      const target = host.querySelector(section.selector) || host;
      target.innerHTML = cartItems.getSectionInnerHTML(html, section.selector);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-atlas-addon]');
    if (!button) return;
    const drawer = button.closest('cart-drawer');
    const page = drawer ? null : button.closest('cart-items');
    if (drawer && typeof drawer.renderContents !== 'function') return;
    if (!drawer && !(page && typeof page.getSectionsToRender === 'function')) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    const id = Number(button.dataset.atlasAddon);
    const sections = drawer
      ? ['cart-drawer', 'cart-icon-bubble']
      : page.getSectionsToRender().map((section) => section.section);
    fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id, quantity: Number(button.dataset.quantity) || 1, properties: { _atlas_addon: button.dataset.place || 'drawer' } }],
        sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json().then((json) => ({ ok: response.ok, json })))
      .then(({ ok, json }) => {
        if (!ok || !json.sections) throw new Error(json.description || 'add failed');
        if (drawer) drawer.renderContents({ id, sections: json.sections });
        else renderPage(page, json);
        syncArm();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'atlas-addons', productVariantId: id, cartData: json });
        }
      })
      .catch(() => {
        // cart page shows the error (min qty, stock)
        window.location.href = window.routes ? window.routes.cart_url : '/cart';
      });
  });
})();
